"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenRewarderStorageV1Factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "allPartnerTokens",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "borrowSpeeds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "supplySpeeds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tectonicSocketAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b506101e6806100206000396000f3fe608060405234801561001057600080fd5b50600436106100575760003560e01c80630a2247421461005c5780630e427a0e1461009a5780632a19b0f4146100c55780635c975abb146100d8578063f0f631df146100f5575b600080fd5b61008761006a366004610166565b600360209081526000928352604080842090915290825290205481565b6040519081526020015b60405180910390f35b6000546100ad906001600160a01b031681565b6040516001600160a01b039091168152602001610091565b6100ad6100d3366004610198565b610120565b6005546100e59060ff1681565b6040519015158152602001610091565b610087610103366004610166565b600260209081526000928352604080842090915290825290205481565b6001818154811061013057600080fd5b6000918252602090912001546001600160a01b0316905081565b80356001600160a01b038116811461016157600080fd5b919050565b60008060408385031215610178578182fd5b6101818361014a565b915061018f6020840161014a565b90509250929050565b6000602082840312156101a9578081fd5b503591905056fea26469706673582212201f49cde7f816c724596667dfc44c760b4208043a84f8f30606577dc89abe9a6864736f6c63430008030033";
class TokenRewarderStorageV1Factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TokenRewarderStorageV1Factory = TokenRewarderStorageV1Factory;
TokenRewarderStorageV1Factory.bytecode = _bytecode;
TokenRewarderStorageV1Factory.abi = _abi;
//# sourceMappingURL=TokenRewarderStorageV1Factory.js.map